import * as colors from '../../styles/colors';

export const defaultTheme = {
  VyInputInputContainerBackground: colors.backgroundWhite,
  VyInputInputContainerBorderColor: colors.darkGrey,
  VyInputStyledInputTextColor: colors.blueGrey80,
};
